<template>
  <div class="review-card">
    <div class="review-card__header">
      <initial-avatar
        :name="author"
        class="review-card__avatar"
      />
      <span class="review-card__author">{{ author }}</span>
    </div>

    <div class="review-card__stars" :aria-label="`Rating: ${rating} out of 5`">
      <img
        v-if="source === 'google'"
        :src="GOOGLE_LOGO_URL"
        alt="Google"
        class="review-card__google-logo"
      />
      <stars :score="rating"></stars>
    </div>

    <div v-if="text" class="review-card__body">{{ text }}</div>

    <div v-if="formattedDate" class="review-card__date">Posted on {{ formattedDate }}</div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Stars from './stars.vue';
import InitialAvatar from './initial-avatar.vue';

const GOOGLE_LOGO_URL = 'https://assets.kinside.com/static/web/google-logo.png';

const props = defineProps({
  author: {
    type: String,
    required: true,
  },
  rating: {
    type: Number,
    required: true,
  },
  text: {
    type: String,
    default: null,
  },
  date: {
    type: String,
    required: true,
  },
  source: {
    type: String,
    required: true,
    validator(value) {
      return ['google', 'kinside'].includes(value);
    },
  },
});

const formattedDate = computed(() => {
  if (!props.date) return null;

  const parsed = new Date(props.date);
  if (Number.isNaN(parsed.getTime())) return null;

  return parsed.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
});
</script>

<style lang="scss" scoped>
.review-card {
  &__header {
    display: flex;
    align-items: center;
    gap: var(--grid-unit);
    margin-bottom: calc(var(--grid-unit) / 2);
  }

  &__avatar {
    width: 31px;
    height: 31px;
    flex-shrink: 0;
  }

  &__google-logo {
    width: 27px;
    height: 27px;
    margin-left: 3px;
    margin-right: calc(var(--grid-unit) / 2);
    flex-shrink: 0;
  }

  &__author {
    font-weight: 600;
    color: var(--gray-900);
  }

  &__stars {
    display: flex;
    align-items: center;
    margin-bottom: var(--grid-unit);
  }

  &__body {
    color: var(--gray-900);
    margin-bottom: calc(var(--grid-unit) / 2);
    line-height: 1.5;
  }

  &__date {
    color: var(--gray-500);
    font-size: 10px;
  }
}
</style>
